import axios from 'axios'
import store from '../store'
import router from '../router'

const axiosInstance = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    }
})

// 请求拦截器
axiosInstance.interceptors.request.use(
    config => {
        const token = store.state.user.token
        if (token) {
            // 确保所有请求都带上 token，包括文件上传
            config.headers['ct-sob-admin-token'] = token.trim()
        }
        
        // 如果是验证码请求，移除不必要的头信息
        if (config.url.includes('/sys/captcha_text')) {
            config.headers = {
                'Accept': 'image/*'
            }
        }
        
        // 如果是文件上传请求，不设置 Content-Type，让浏览器自动设置
        if (config.url.includes('/md/image/') || config.url.includes('/md/mp3') || config.url.includes('/md/mp4')) {
            delete config.headers['Content-Type']
        }
        
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
axiosInstance.interceptors.response.use(
    response => {
        // 如果是验证码请求，直接返回
        if (response.config.url.includes('/sys/captcha_text')) {
            return response;
        }
        
        // 检查登录状态
        if (response.data && response.data.code === 50001) {
            store.dispatch('logout');
            // 使用路由方式跳转，而不是 window.location
            if (!window.location.hash.includes('/login')) {
                router.push('/login');
            }
            return Promise.reject(new Error('未登录或登录已过期'));
        }
        return response;
    },
    error => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            store.dispatch('logout');
            if (!window.location.hash.includes('/login')) {
                router.push('/login');
            }
        }
        return Promise.reject(error);
    }
)

export default {
    axiosInstance,  // 导出 axios 实例
    requestGet: function(url, config = {}) {
        return new Promise((resolve, reject) => {
            axiosInstance.get(url, config)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    requestPost: function(url, data = {}, config = {}) {
        return new Promise((resolve, reject) => {
            axiosInstance.post(url, data, config)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    requestPut: function(url, data = {}) {
        return new Promise((resolve, reject) => {
            axiosInstance.put(url, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    requestDelete: function(url) {
        return new Promise((resolve, reject) => {
            axiosInstance.delete(url)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}
